<template>
    <v-dialog
        v-model="visible"
        max-width="600"
    >
        <v-card>
            <v-card-title>
                <v-btn
                    variant="text"
                    icon
                    class="mr-2"
                    @click="visible = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

                <template v-if="type === 'export'">
                    {{ i18n.t('rights.usersTitleExport') }}
                </template>
                <template v-else>
                    {{ i18n.t('rights.usersTitle') }}
                </template>
            </v-card-title>
            <v-card-text>
                <rights-users-core
                    :id="id"
                    :module="module"
                    :i18n="i18n"
                    :type="type" />
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: {
        module: {
            type: String,
            default: null
        },
        id: {
            type: [String, Number],
            default: null
        },
        i18n: {
            type: Object,
            default: null
        },
        type: {
            type: String,
            default: 'edit'
        }
    },
    data () {
        return {
            visible: true
        }
    }
}
</script>
